import { Component, OnInit, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
	host: { 
		'( document: click )': 'onClickOutside( $event )'
	},
  selector: 'yd-select',
  templateUrl: './yd-select.component.html',
  styleUrls: ['./yd-select.component.css']
})
export class YourDreamSelect implements OnInit {

	isDropdownOpened: boolean = false;
	selectedValue_text: string = '';
	isTouched: boolean = false;
	isValid: boolean = false;
	searchValue: string = '';
	selectOptionsFiltered: Array<any> = [];
	dropdownTopOffset: number = 34;

	@ViewChild( "mainContainer" )
	mainContainer: ElementRef;

	constructor ( ) { }

	@Input( )
	selectOptions: Array<any> = [{value:'',text:''}];
	@Input( )
	selectedValue: string = '';
	@Input( )
	elementID: string = '';
	@Input( )
	isRequired: boolean = false;
	@Input( )
	isDisabled: boolean = false;
	@Input( )
	search: boolean = true;
	@Input( )
	height: number = 34;
	@Input( )
	width: number;
	@Input( )
	uncheckValue: boolean = false;

	@Output( )
	onMakeChange = new EventEmitter<any>( );

	ngOnInit ( ) { 
		this.filterResults( );
	}

	ngAfterViewInit ( ) {
		this.getSelectedValueText( );
	}

	ngOnChanges( changes ) {
		if ( changes.isRequired ) this.isValid = ( this.selectedValue && this.isRequired ) || !this.isRequired;
    if ( changes.selectedValue || changes.selectOptions ) {
			this.getSelectedValueText( );
			this.isValid = ( this.selectedValue && this.isRequired ) || !this.isRequired;
    }
    if ( changes.selectOptions ) this.filterResults( );
  }

	// Best way for manual trigger select change event
	changeValue ( _object ) {
		if ( _object.disabled ) return;
		this.selectChangeValue( _object.value );
	}

	openDropdown ( ) {
		this.searchValue = '';
		this.filterResults( );
		this.dropdownTopOffset = ( this.search && this.selectOptions.length > 4 ) ? this.height * 2 + 2 : this.height;
		if ( this.isDisabled == false ) this.isDropdownOpened = true;
	}

	closeDropdown ( ) {
		this.isTouched = true;
		this.isDropdownOpened = false;
	}

	getSelectedValueText ( optionsChanged? ) {
		let hasValue = false;
		this.selectOptions.forEach( _option => {
			if ( _option.value == this.selectedValue ) {
				this.selectedValue_text = _option.text;
				hasValue = true;
			}
		});
		if ( this.selectedValue ) this.isValid = true;
		if ( !hasValue && !this.uncheckValue ) {
			this.isValid = false;
		}
	}


	onClickOutside ( event ) {

		let clickElement = event.target,
				_closest = clickElement.closest( '.yd__wrapper' );


		if ( !this.isDropdownOpened ) return;

		if ( ( !_closest || this.mainContainer.nativeElement != _closest ) && 
			this.mainContainer.nativeElement != clickElement && 
			clickElement.getAttribute( 'for' ) != this.elementID ) {
			this.closeDropdown( );
		}

	}

  onKeydown( event ) { 
    if ( this.isDropdownOpened && ( event.key == 'Escape' || event.key == 'Tab' ) ) this.closeDropdown( );
  }

	filterResults ( ) {
		let _olc: string = '';
		this.selectOptionsFiltered = [];
		this.selectOptions.forEach( _option => {
			_olc = _option.text.toLowerCase( );
			if ( _olc.indexOf( this.searchValue.toLowerCase( ).trim( ) ) > -1  ) this.selectOptionsFiltered.push( _option );
		});
	}

	selectChangeValue ( value ) {
		this.selectedValue = value;
		let _hasChange = false;
		if ( this.selectedValue != value ) _hasChange = true;
		this.selectedValue = value;
		this.getSelectedValueText( );
		// this.selectedValue_text = _object.text;
		this.isValid = ( this.selectedValue && this.isRequired ) || !this.isRequired;
		this.onMakeChange.emit( { value: this.selectedValue } );
		this.closeDropdown( );
	}

}


// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/yd-select/yd-select.component.ts